module.exports = __webpack_public_path__ + "au.ecef4318.svg";